import { getHours } from "@clipboard-health/date-time";
import { type TimeSlot } from "@src/appV2/redesign/Shift/types";
import { getHours as getLocalHours } from "date-fns";

/**
 * Start time ranges for each time slot.
 * These are non-overlapping ranges used to determine which time slot
 * a shift belongs to based on its start time.
 *
 * AM:  0:00 - 10:59
 * PM:  11:00 - 16:59
 * NOC: 17:00 - 23:59
 */
const TIME_SLOT_RANGES = {
  am: { startHour: 0, endHour: 10 },
  pm: { startHour: 11, endHour: 16 },
  noc: { startHour: 17, endHour: 23 },
} as const;

/**
 * Returns the time slot derived from a given start time.
 * Uses non-overlapping ranges so every hour maps to exactly one slot.
 *
 * Matches the logic from the calendar view's `getRecommendedTimeSlot`.
 */
export function getDerivedTimeSlot(startTime: Date, timezone?: string): TimeSlot {
  const hour = timezone ? getHours(startTime, { timeZone: timezone }) : getLocalHours(startTime);

  if (hour >= TIME_SLOT_RANGES.am.startHour && hour <= TIME_SLOT_RANGES.am.endHour) {
    return "am";
  }

  if (hour >= TIME_SLOT_RANGES.pm.startHour && hour <= TIME_SLOT_RANGES.pm.endHour) {
    return "pm";
  }

  return "noc";
}
